import React from 'react';
import { Droplet, Flame, Snowflake } from 'lucide-react';
import { FadeIn } from './FadeIn';
const cards = [{
  icon: Droplet,
  title: '1. Hidratación Profunda',
  description: 'Restauramos la barrera cutánea con ingredientes biomiméticos que tu piel reconoce y absorbe, eliminando la sequedad desde la raíz.'
}, {
  icon: Flame,
  title: '2. Anti-inflamación',
  description: 'Calmamos la respuesta inmune hiperactiva de tu cuero cabelludo. El rojo desaparece. La picazón se detiene. El confort vuelve.'
}, {
  icon: Snowflake,
  title: '3. Regulación Térmica',
  description: 'Equilibramos la producción de sebo y la temperatura local para evitar que los hongos y bacterias proliferen nuevamente.'
}];
export function TriadaSection() {
  return <section className="py-24 md:py-32 bg-cream-100 relative overflow-hidden" data-id="element-188">
      {/* Background decoration */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none opacity-30" data-id="element-189">
        <div className="absolute top-[-20%] right-[-10%] w-[500px] h-[500px] bg-sage-200 rounded-full blur-[100px]" data-id="element-190" />
        <div className="absolute bottom-[-20%] left-[-10%] w-[500px] h-[500px] bg-cream-300 rounded-full blur-[100px]" data-id="element-191" />
      </div>

      <div className="max-w-6xl mx-auto px-4 relative z-10" data-id="element-192">
        <FadeIn className="text-center mb-20" data-id="element-193">
          <span className="text-sage-600 font-medium uppercase tracking-wider text-sm mb-3 block" data-id="element-194">
            El Mecanismo Clínico
          </span>
          <h2 className="font-serif text-4xl md:text-5xl text-warm-900 mb-6" data-id="element-195">
            La Triada 3×3
          </h2>
          <p className="text-warm-600 max-w-2xl mx-auto text-lg" data-id="element-196">
            Un enfoque científico tridimensional para devolverle la salud a tu
            cuero cabelludo, atacando las tres causas raíz del problema
            simultáneamente.
          </p>
        </FadeIn>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-197">
          {cards.map((card, index) => <FadeIn key={index} delay={index * 0.2} direction="up" className="h-full" data-id="element-198">
              <div className="bg-white p-8 md:p-10 rounded-2xl shadow-sm border border-sage-50 h-full flex flex-col items-center text-center hover:shadow-md transition-shadow duration-300" data-id="element-199">
                <div className="w-16 h-16 bg-sage-50 rounded-full flex items-center justify-center mb-6 text-sage-500" data-id="element-200">
                  <card.icon className="w-8 h-8" data-id="element-201" />
                </div>
                <h3 className="font-serif text-2xl text-warm-900 mb-4" data-id="element-202">
                  {card.title}
                </h3>
                <p className="text-warm-600 leading-relaxed" data-id="element-203">
                  {card.description}
                </p>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}